<template>
  <form @submit.prevent="" novalidate ref="form">
    <div class="container-fluid">
      <div class="snippet general-event-config-snippet">
        <div class="form-group row mb-4">
          <div class="col-lg-6">
            <label>Question*</label>
            <div class="kt-input-icon">
              <input type="text" class="form-control" name="question" maxlength="200" placeholder="Enter Question for Faq" :value="item.question"  @input="updateQuestion" />
           
              <ValidationMessages :element="v$.item.question" />
            </div>
          
          </div>


          <div class="col-lg-6">
            <label>Answer*</label>
           <input type="text" class="form-control" name="answer" maxlength="200" placeholder="Enter answer for faq"  :value="item.answer" @input="updateAnswer" />
            
          </div>
        </div>
        
      </div>

      
      
      <div class="form-group row">
        <div class="offset-md-10 col-md-2">
          <div class="setting_wrapper">
            <button type="button" class="btn btn-primary" @click="submitForm">Save</button>
           &nbsp; <button type="button" class="mb-1 mt-1 me-1  btn btn-secondary" @click="cancelClick">Cancel</button>
   
          </div>
        </div>
      </div>

      <FlashMessage group="faq_create" />
    </div>
  </form>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import ObjectID from 'bson-objectid';
import _ from 'lodash';


import { gettingErrorMessage } from "@/services/GetValidationMessage";
import ValidationMessages from "@/components/Commons/Validations/ValidationMessages";
import {
  useVuelidate
} from '@vuelidate/core'
import {
  required,
  email,
} from '@vuelidate/validators'


export default {
  name: "FaqCreate",
  components: {       
        ValidationMessages
    },
  data() {
    return {
      moduleId: ObjectID(),
      selectedLanguage: null,
      languages: []
    }
  },

  setup() {
        return {
            v$: useVuelidate()
        }
    },

    validations() {
        return {
            item: {
               
                title: {
                    required,
                }
            }
        };
    },
  computed: {
   // ...mapGetters("EventsSingle", {event: "item"}),
    ...mapGetters("TagsSingle", ["item"])
  },
  

  beforeUnmount() {
    this.resetState();
    delete this.$flashMessage.groups.tag_create;
    },
  mounted() {
    // this.fetchEvent(this.$route.params.event_id)
  },
 
  methods: {
     ...mapActions('FaqIndex', {
        fetchAllSponsors: "fetchData",
   }),
    ...mapActions('FaqSingle', [      
      "setQuestion",
      "setAnswer",
      "storeData",
      "resetState"
    ]),

    ...mapActions('FaqSingle', {
      setEditId:"setEditId"
    }),

    
    updateQuestion(e) {
      this.setQuestion(e.target.value)
    },
    updateAnswer(e) {
      this.setAnswer(e.target.value);
    },
   
   
    validate_file(fileInfo) {
      if (_.has(fileInfo, 'key'))
        return fileInfo;
      return null;
    },


    cancelClick() {
      this.resetState()
    },
    async submitForm(e) {
      e.preventDefault();

  
      this.storeData(this.$route.params.event_id)
          .then(async () => {

            this.fetchAllSponsors(this.$route.params.event_id);
            
            this.$flashMessage.show({
              group : 'faq',
              type  : 'success',
              title : 'Success',
              time  :1200,
              html  : "<ul><li>FAQ has been created successfully.</li></ul>",
            });
           
                
          })
          .catch((error) => {
                    let html = gettingErrorMessage(error);
                    
                    //if (error.response.data.error) {
                        this.$flashMessage.show({
                            group: 'faq_create',
                            type: 'error',
                            title: 'Failed',
                            text: html || 'Something went wrong',
                            html: html
                        });
                   // }
                })
    },
     cancelEdit() {
    
    }
  }
}
</script>

<style scoped lang="scss">
.form-btn {
  color: #201e1eba;
  padding: 9px;
  margin-left: 5px;
  background: #c0cdd345;
  border-radius: 4px;
  border: 1px solid #80808054;

  &.save-btn {
    background: rgba(210, 206, 201, 0.27);
  }
}
</style>